// Shared renderer for article body blocks (paragraphs, subheadings,
// reflection questions, "Try this" activities). Used by the public article
// page and the dashboard preview — same visual design in both.
export const ArticleBody = ({ blocks = [] }) => (
  <>
    {blocks.map((block, i) => {
      if (block.type === "h2") {
        return (
          <h2
            key={i}
            className="mb-4 mt-12 font-display text-2xl tracking-tight text-navy sm:text-3xl"
          >
            {block.text}
          </h2>
        );
      }
      if (block.type === "questions") {
        return (
          <div
            key={i}
            className="my-10 border border-navy/15 bg-offwhite p-7 sm:p-9"
            data-testid="reflection-questions"
          >
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-crimson">
              Three questions to sit with
            </p>
            <ol className="mt-5 space-y-4">
              {(block.items || []).map((q, qi) => (
                <li
                  key={qi}
                  className="flex gap-4 text-base leading-relaxed text-charcoal/85"
                >
                  <span className="font-display text-xl leading-snug text-navy">
                    {qi + 1}.
                  </span>
                  {q}
                </li>
              ))}
            </ol>
          </div>
        );
      }
      if (block.type === "try") {
        return (
          <div
            key={i}
            className="my-10 border-l-4 border-crimson bg-offwhite p-7 sm:p-9"
            data-testid="try-this"
          >
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-navy/60">
              Try this
            </p>
            <p className="mt-3 text-base leading-relaxed text-charcoal/85">
              {block.text}
            </p>
          </div>
        );
      }
      return (
        <p
          key={i}
          className="mb-6 text-base leading-[1.85] text-charcoal/85 sm:text-lg"
        >
          {block.text}
        </p>
      );
    })}
  </>
);
